export default "__VITE_ASSET__CW2SAukO__"